import { useRef } from "react";

import { MobileTopNav } from "@/components/molecules/MobileTopNav";
import { MobileBottomNav } from "@/components/molecules/MobileBottomNav";
import { Rail } from "@/components/organisms/Rail";
import { RailVariant } from "@/components/organisms/Rail/types";
import { BrowsePage } from "@/components/pages/BrowsePage";

import styles from "./Mobile.module.scss";

function Mobile() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles["mobile"]} ref={scrollContainerRef}>
      <MobileTopNav scrollContainerRef={scrollContainerRef} />
      <Rail variant={RailVariant.ShowcaseCarousel} snap>
        <div
          className={styles["showcase-placeholder"]}
          style={{ background: "red" }}
        />
        <div
          className={styles["showcase-placeholder"]}
          style={{ background: "orange" }}
        />
        <div
          className={styles["showcase-placeholder"]}
          style={{ background: "yellow" }}
        />
      </Rail>
      <BrowsePage
        slug="/home"
        fetchTileDetails={true}
        skipPersonalized={false}
        showMobileContent={true}
        scrollContainerRef={scrollContainerRef}
      />

      <MobileBottomNav />
    </div>
  );
}

export { Mobile };
